<script lang="ts" setup>
import { computed, reactive } from "vue";
import StopInfoPipForm from "@/views/trips/components/forms/StopInfoPipForm.vue";
import { usePipStore } from "@/store/pip.store";
import { getStopInfoTitle } from "@/utils/stopInfoTitle";
import type { RouteStopDto, TripDto, TripRouteDto } from "@/api/trips/dto/trip.dto";
import type { StopInfoPipProps } from "@/types/props";

const pipStore = usePipStore();

const props = withDefaults(
  defineProps<{
    trip: TripDto;
    route: TripRouteDto;
    stop: RouteStopDto;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emits = defineEmits(["save"]);

defineOptions({ inheritAttrs: false });

const title = computed<string>(() => getStopInfoTitle(props.stop));

const pipProps = reactive<StopInfoPipProps>({
  get trip() {
    return props.trip;
  },
  get route() {
    return props.route;
  },
  get stop() {
    return props.stop;
  },
  get title() {
    return title.value;
  },
  preload: true,
  readonly: true,
});

async function showInfo(): Promise<void> {
  await pipStore.open({
    component: StopInfoPipForm,
    props: pipProps,
    on: {
      close: () => pipStore.close(),
      save: () => emits("save"),
    },
  });
}
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="outlined"
    @click="showInfo"
  >
    View info
  </v-btn>
</template>

<style lang="scss" scoped></style>
